module.exports = __webpack_public_path__ + "static/media/03.d4a3181a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rank/03.jpg
// module id = 848
// module chunks = 0